import { render, staticRenderFns } from "./DetailClass.vue?vue&type=template&id=d31af596"
import script from "./DetailClass.vue?vue&type=script&lang=js"
export * from "./DetailClass.vue?vue&type=script&lang=js"
import style0 from "./DetailClass.vue?vue&type=style&index=0&id=d31af596&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports